module.exports = __webpack_public_path__ + "img/news-defult-img.e6d1a51e.svg";